var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdjust11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1088_1777)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.874802 4.98872C1.11188 2.47063 3.27009 0.625 5.764 0.625H14.2285C16.7096 0.625 18.863 2.45239 19.1112 4.958C19.4638 8.51659 19.4631 11.4397 19.1081 15.0352C18.8604 17.5431 16.7068 19.375 14.2223 19.375H5.76797C3.27197 19.375 1.11347 17.5265 0.876683 15.0069C0.542005 11.4458 0.540837 8.53587 0.874802 4.98872ZM5.625 6.875C5.625 5.66687 6.60437 4.6875 7.8125 4.6875C8.80344 4.6875 9.6405 5.34641 9.9094 6.25H13.75C14.0952 6.25 14.375 6.52981 14.375 6.875C14.375 7.22019 14.0952 7.5 13.75 7.5H9.9094C9.6405 8.40359 8.80344 9.0625 7.8125 9.0625C6.60437 9.0625 5.625 8.08313 5.625 6.875ZM12.1875 10.9375C13.3956 10.9375 14.375 11.9169 14.375 13.125C14.375 14.3331 13.3956 15.3125 12.1875 15.3125C11.1966 15.3125 10.3595 14.6536 10.0906 13.75H6.25C5.90481 13.75 5.625 13.4702 5.625 13.125C5.625 12.7798 5.90481 12.5 6.25 12.5H10.0906C10.3595 11.5964 11.1966 10.9375 12.1875 10.9375Z",
    fill: "#D42124"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1088_1777"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdjust11);
export default __webpack_public_path__ + "static/media/adjust(1)1.ece0bfac63e6024b3ecf1024c464b33c.svg";
export { ForwardRef as ReactComponent };